// @codekit-prepend "jquery.js"
// @codekit-prepend "jquery.fancybox.js"
// @codekit-prepend "jquery.flexslider.js"
// @codekit-prepend "jquery.superfish.js"
// @codekit-prepend "jquery.superLabels.min.js"
// @codekit-prepend "jquery.sparkbox-select.js"
// @codekit-prepend "modernizr-1.7.min.js"


// Add Object.assign function
if (typeof Object.assign != 'function') {
    Object.assign = function (target) {
        'use strict';
        if (target == null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        target = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source != null) {
                for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            }
        }
        return target;
    };
}




jQuery(document).ready(function ($) {

    if ($('#tips-filter-0, #tips-filter-1, #tips-filter-2').length > 0) {
        $('#tips-filter-0, #tips-filter-1, #tips-filter-2').change(function () {
            $('#tips-filter-form').submit();
        });
    }

    function superlabel() {
        $('.page-content form').superLabels({
            labelLeft: 10,
            labelTop: 9
        });

        $('.site-header form').superLabels({
            labelLeft: 10,
            labelTop: 9
        });

    }

    superlabel();

    $("#searchform").preventEmptySubmit();

    // Put all your jQuery goodness in here.

    // Fetch description for gallery images

    // Gallery images
    $(".lightbox a").fancybox({
        fitToView: true,
        width: '90%',
        height: '90%',
        autoSize: false,
        closeClick: true,
        openEffect: 'elastic',
        closeEffect: 'elastic',
        beforeShow: function () {
            this.title = $(this.element).find('img').attr('alt');
        }
    });


    /*$('.sparkbox-custom').sbCustomSelect({
        appendTo: 'body'
    });*/


    // Remove width & height attributes from images (added by default in WordPress)
    $('img').removeAttr('width').removeAttr('height');

    // Remove style attribute on image captions, which sets a fixed width by default
    $('.wp-caption').removeAttr('style');

    // Main menu - Duplicate main menu for responsivness
    var mobileMenuClone = $('.main-menu').clone().attr('id', 'main-menu-mobile');

    // Main menu - Make main menu drop down
    $('.main-menu').superfish({
        delay: 200,
        animation: { opacity: 'show', height: 'show' },
        speed: 'fast',
        cssArrows: false,
        disableHI: true,
        hoverClass: 'hover'
    });

    $(".sf-menu ul:last").css("margin-left", -200); // patch to stop last menu going off screen

    // Main menu - Prepend the duplicated mobile menu
    // function responsive_menu() {
    //     var windowWidth = $(window).width();

    //     if( windowWidth <= 768 ) {

    //         // Show the mobile menu, hide the main menu
    //         if( !$('#menu-toggle').length ) {

    //             // Add our button and cloned menu if they don't already exist
    //             $('<a id="menu-toggle" class="menu-toggle" href="#main-menu-mobile" />').prependTo('.site');
    //             mobileMenuClone.insertAfter('#menu-toggle').wrap('<nav class="main-nav-mobile" />');
    //             responsive_menu_listener();
    //         }
    //     }

    //     else {
    //         mobileMenuClone.css('display', 'none');
    //     }
    // }
    // responsive_menu();


    // Main menu - Fire the event listener
    // function responsive_menu_listener() {

    //     $('#menu-toggle').click(function(e) {

    //         if( $('html').hasClass('ie9') && !$('html').hasClass('ie8') ) {

    //             var mobileMenu = $('#main-menu-mobile');

    //             if( mobileMenu.css('display') === 'block' ) {
    //                 mobileMenu.css({
    //                     'display' : 'none'
    //                 });
    //             } else {
    //                 mobileMenu.css({
    //                     'display' : 'block',
    //                     'height' : 'auto',
    //                     'z-index' : 999,
    //                     'position' : 'absolute'
    //                 });
    //             }

    //         } else {

    //             $('#main-menu-mobile').stop().slideToggle(500);

    //         }

    //         e.preventDefault();
    //     });
    // }

    if (!$('html').hasClass('ie9') && !$('html').hasClass('ie8')) {
        window.addEventListener("orientationchange", function () {
            $('.main-nav > ul').removeAttr('style');
        }, false);
    }


    $('.type-of-reservation-chose').click(function (event) {
        $('.overley').toggleClass('isActive');
    })


    $('.overley-close').click(function () {
        if ($('.overley').hasClass('isActive')) {
            $('.overley').toggleClass('isActive');
        }
    })

    $('.img-goal').hover(function () {
        $('.img-goal').addClass('img-overley');
        $(this).removeClass('img-overley')
    }, function () {
        $('.img-goal').removeClass('img-overley');
    })


    $(document).click(function (e) {
        if ($('.overley').hasClass('isActive')) {
            if (!$('.select_info_wrapper').is(e.target) && !$('.select_info > h4').is(e.target) && !$('.select_info > p').is(e.target) && !$('.type-of-reservation-chose').is(e.target)) {
                $('.overley').toggleClass('isActive');
            }
        }
    })


    // //Display search on mobile
    $("#search-toggle").click(function (event) {
        $(".search-head").toggleClass('active');
    });

    $(".wysija-submit").val("s");
});

// Make links pop up
jQuery(document).on('click', 'a.popup', function ($) {
    var rel = $(this).attr('rel');
    var options = null;
    if (rel) {
        options = rel.split(",");
    }
    var newwindow = window.open($(this).attr('href'), '_newWindow', (options) ? 'height=' + options[1] + ',width=' + options[0] : '');
    if (window.focus) {
        newwindow.focus();
    }
    return false;
});




/**
* Stop empty searches
*
* @author Thomas Scholz http://toscho.de
* @param  $ jQuery object
* @return bool|object
*/
(function ($) {
    $.fn.preventEmptySubmit = function (options) {
        var settings = {
            inputselector: "#s",
            msg: "Du har inte fyllt i något sökvärde"
        };
        if (options) {
            $.extend(settings, options);
        };
        this.submit(function () {
            var s = $(this).find(settings.inputselector);
            if (!s.val()) {
                alert(settings.msg);
                s.focus();
                return false;
            }
            return true;
        });
        return this;
    };
})(jQuery);


/**
* map
*/
jQuery(function ($) {
    // Select county event
    $('.svg-map__county, .newspaper-map__nav-item').on('click', selectCounty);
    $('.svg-map__county, .newspaper-map__nav-item').on('mouseover', false, { over: true }, highlightOnHover);
    $('.svg-map__county, .newspaper-map__nav-item').on('mouseleave', false, { over: false }, highlightOnHover);
    $('.map-search__reset').on('click', resetMapSearch);

    // mobile nav
    $('.county-list__mobile').on('change', selectCountyMobile);

    function selectCountyMobile() {
        var currentID = $('option:selected').data('id');
        updateMapUI(currentID);
    }

    function selectCounty(e) {
        // Selected county values
        var currentID = $(this).data('id');
        $('.county-list__mobile').val(currentID);
        updateMapUI(currentID);
    }

    function updateMapUI(currentID) {
        var currentName = $('.newspaper-map__nav li[data-id=' + currentID + ']').text();
        // Select county on map and menu list
        $('.svg-map__county, .newspaper-map__nav-item').removeClass('selected');
        $('*[data-id=' + currentID + ']').addClass('selected');
        // Update header
        $('.map-search__current-county').text(currentName);

        filterResult(currentID);
    }

    function resetMapSearch() {
        $('.svg-map__county, .newspaper-map__nav-item').not(this).removeClass('selected');
        filterResult('all');
    }

    function highlightOnHover(e) {
        var id = $(this).data('id');
        if (e.data.over) {
            $('*[data-id=' + id + ']').addClass('hover');
        } else {
            $('*[data-id=' + id + ']').removeClass('hover');
        }
    }

    function updateResultCounter() {
        var count = $('.newspaper-list__item').length;
        $('.map-search__counter').text(count);
    }

    if ($('#shuffle-container').length > 0) {
        var Shuffle = window.Shuffle;
        var element = document.querySelector('#shuffle-container');

        var shuffleInstance = new Shuffle(element, {
            itemSelector: '.newspaper-list__item',
            speed: 800,
        });

        var initHeight = false;
        shuffleInstance.on(Shuffle.EventType.LAYOUT, function () {

            if ($('.newspaper-list__item').length > 0 && initHeight == false) {
                var minHeight = 0;
                var currentHeight = 0;
                $('.newspaper-list__item').each(function (index, element) {
                    currentHeight = $(element).height();
                    if (currentHeight > minHeight) {
                        minHeight = currentHeight;
                    }
                });
                $('.newspaper-list__item-inner').css('height', minHeight);
                initHeight = true;
                shuffleInstance.layout();
            }
        });
    }


    function filterResult(id) {
        if (typeof id == 'undefined') { id = 'all'; }
        if (id == 'all') {
            shuffleInstance.filter();
        } else {
            shuffleInstance.filter([id]);
        }
        $('.map-search__counter').text($('.shuffle-item--visible').length);
    }


    /******************************************************************************\
    Mobile menu
\******************************************************************************/
    // Hide mobile menu on wide screens
    $(window).resize(function () {
        if (window.innerWidth >= 1024) {
            $('.mobile-menu__wrapper--open').removeClass('mobile-menu__wrapper--open');
            $('.mobile-menu__wrapper__overlay--open').removeClass('mobile-menu__wrapper__overlay--open');
            $('.hamburger').removeClass('is-active');
        }
    });

    // Open mobile menu
    $('.header-hamburger, .mobile-menu__close').on('click', function (e) {
        $('body').toggleClass('mobile-menu--open');
        $('.hamburger').toggleClass('is-active');
        $('.mobile-menu__wrapper').toggleClass('mobile-menu__wrapper--open');
        $('.mobile-menu__wrapper__overlay').toggleClass('mobile-menu__wrapper__overlay--open');
        e.stopImmediatePropagation();
    });

    // Toggle subpages in mobile menu
    $('.main-menu--mobile .menu-item-has-children > a').append('<span class="menu-item__toggle"></span>');
    $('.menu-item__toggle').on('click', function (e) {
        e.preventDefault();
        if (!$(this).hasClass('toggling')) {
            $target = $(this);
            $(this).parent().next('.sub-menu').slideToggle(function () {
                $target.removeClass('toggling');
            });
            $(this).addClass('toggling');
            $(this).toggleClass('menu-item__toggle--open');
            $(this).closest('li').toggleClass('menu-item--open');
        }
    });

    $('.main-nav--mobile li.current_page_parent, main-nav--mobile li.current_page_ancestor').addClass('menu-item--open');

    // end mobile

    $('.first-slider').slick({
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    prevArrow: null,
                    nextArrow: null
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    infinite: true,
                    speed: 300,
                    centerMode: true,
                    prevArrow: null,
                    nextArrow: null
                }
            },
            {
                breakpoint: 480,
                settings: {

                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    infinite: true,
                    speed: 300,
                    centerMode: true,
                    prevArrow: null,
                    nextArrow: null
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    // news slider

    $('.news-slider').slick({
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    prevArrow: null,
                    nextArrow: null
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    prevArrow: null,
                    nextArrow: null
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    prevArrow: null,
                    nextArrow: null
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });


    /******************************************************************************\
       SMOOTH SCROLLING 
     \******************************************************************************/
    $('a[href*=#]:not([href=#])').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top
                }, 1000);
                return false;
            }
        }
    });

    // isotope
    // init Isotope
    var $grid = $('.my-grid').isotope({
        itemSelector: '.lektionstips',
    });

    // filter functions
    var filterFns = {
        // show if number is greater than 50
        numberGreaterThan50: function () {
            var number = $(this).find('.number').text();
            return parseInt(number, 10) > 50;
        },
        // show if name ends with -ium
        ium: function () {
            var name = $(this).find('.name').text();
            return name.match(/ium$/);
        }
    };

    var archive_is_showing = false;
    var filter_archive = ''

    // bind filter button click
    $('#filters').on('click', 'button', function () {
        var filterValue = $(this).attr('data-filter');
        // use filterFn if matches value
        filterValue = filterFns[filterValue] || filterValue;
        if (filterValue == '.lektionstips_categories-archive') {
            findArkive();
            filter_archive = filterValue
            archive_is_showing = true
        } else {
            if (archive_is_showing) {
                findArkive()
                archive_is_showing = false
            }
        }

        $grid.isotope({ filter: filterValue });
    });

    $('.filter-on-years').on('click', 'button', function () {
        var yearValue = $(this).attr('data-filter');
        var filterValue = $(this).attr('data-type');
        var filterYears = {
            match: function () {
                var year = $(this).attr('data-year');
                return parseInt(year, 10) == parseInt(yearValue, 10);
            },
            lower_then: function () {
                var year = $(this).attr('data-year');
                return parseInt(year, 10) <= parseInt(yearValue, 10);
            },
            all: function () {
                var year = $(this).attr('data-year');
                return parseInt(year, 10) > 0;
            }
        }
        filterValue = filterYears[filterValue] || filterValue
        console.log(filterValue)
        $grid.isotope({ filter: filterValue });
    })

    // find arkive lektion tips and add a class archive-lesson-none

    function findArkive() {
        var allArchive = $('.lektionstips_categories-archive').map(function () {
            $(this).toggleClass('archive-lesson-none');
        })

        $('.archive-text-info').toggleClass('archive-text-none');
        $('.filter-on-years').toggleClass('filter-on-years-none')
    }

    // bind sort button click
    $('#sorts').on('click', 'button', function () {
        var sortByValue = $(this).attr('data-sort-by');
        $grid.isotope({ sortBy: sortByValue });
    });

    // change is-checked class on buttons
    $('.button-group').each(function (i, buttonGroup) {
        var $buttonGroup = $(buttonGroup);
        $buttonGroup.on('click', 'button', function () {
            $buttonGroup.find('.is-checked').removeClass('is-checked');
            $(this).addClass('is-checked');
        });
    });




});



// miki

jQuery